module.exports = __webpack_public_path__ + "static/media/caregiver_slider_phone1.51d740ad.png";